/**
 * Created by jonathan.kernick on 06/09/2016.
 */
var JumpGame = function (gameEndFunc, characterNum, difficultyNum, json, audioJson) {

    var i;

    PIXI.Container.call(this);
    this.json = json;
    this.audioJson = audioJson;
    this.characterNum = characterNum || 0;
    this.difficultyNum = difficultyNum || 0;
    this.gameEndFunc = gameEndFunc;
    this.ignoringDropLimit = false;

    this.heightUnit = CC.WebApp.current.screenHeightMax / 10;
    this.heightScore = 0;

    this.boosting = false;
    this.invincibleTime = 0;
    this.invincibilitySpawnDelay = 0;
    this.invincibilityVisible = false;
    this.extraLifeVisible = false;
    this.hasExtraLife = false;
    this.grappling = false;

    this.score = 0;
    this.platformCount = 100;
    this.platformGenOffset = -600;
    this.platformPool = [];

    this.collectibleCount = 100;
    this.collectiblePool = [];

    this.enemyCount = 100;
    this.enemyPool = [];
    this.showHitBoxes = this.json.show_hit_boxes;

    this.pointsPool = [];
    this.pointsCount = 10;
    this.currentPlatformGenHeight = 0;
    this.originalGravity = 1200;
    this.currentGravity = 1200;
    this.boostGravity = 0;
    this.jumpVelocity = -1200;
    this.controlSpeed = 150;
    this.controlVelocity = 0;
    this.controlVelocityGamma = 0;
    this.playerVelocity = 0;
    this.playerDeathGraphicSwitch = false;
    this.playerDeathGraphicTimer = 0;
    this.dropLimit = 0;
    this.boostTweenValue = 0;
    this.playerBoostGraphicLength = 3;

    this.hitLayer = new PIXI.Container();
    this.platformHitLayer = new PIXI.Container();
    this.platformHitBoxList = [];

    this.cameraContainer = new PIXI.Container();
    this.cameraTarget = new PIXI.Point(0, 0);
    this.platformContainer = new PIXI.Container();
    this.collectibleContainer = new PIXI.Container();
    this.enemyContainer = new PIXI.Container();
    this.pointsContainer = new PIXI.Container();
    this.leftKeyDown = false;
    this.rightKeyDown = false;
    this.score = 0;
    this.playing = false;

    this.closestEnemy = undefined;

    this.scoreText = new PIXI.extras.BitmapText("1", {
        font: this.json.score_text.textSize + "px FuturaBig",
        tint: this.json.score_text.tint
    });
    this.scoreTextShadow = new PIXI.extras.BitmapText("1", {
        font: this.json.score_text.textSize + "px FuturaBig",
        tint: 0x0
    });
    this.scoreTextShadow.alpha = 0.25;
    this.scoreIcon = Widgets.createAsset(this.json.score_text.asset);

    this.playerWidthBounds = 640;

    var tileBackgroundJson = json.tileBackground;
    this.tileBackground = CC.Utility.pixiAtlasTilingSprite(tileBackgroundJson.texture, 640, 3000);
    this.tileBackground.tileHeight = this.tileBackground.texture.frame.height;

    this.colourBackground = new PIXI.Graphics();
    this.colourBackground.beginFill(tileBackgroundJson.colour);
    this.colourBackground.drawRect(-320, -568, 640, 1136);
    this.colourBackground.endFill();

    this.boostBackgroundGraphic = CC.Utility.pixiAtlasTilingSprite(json.boostBackground.texture, 640, 3000);
    this.boostBackgroundGraphic.alpha = 0;
    this.boostBackgroundGraphic.tileHeight = this.boostBackgroundGraphic.texture.frame.height;

    this.boostOverlay = CC.Utility.pixiAtlasTilingSprite(json.boostOverlay.texture, 640, 3000);
    this.boostOverlay.alpha = 0;
    this.boostOverlay.tileHeight = this.boostOverlay.texture.frame.height;
    this.boostOverlay.offset = 0;

    window.jsonTest = this.json;

    this.collectiblePlacement = undefined;
    this.enemyPlacement = undefined;
    this.platformPlacement = undefined;

    this.leaningEaseOff = 1;

    this.mouseX = 0;

    this.challengeValues = [];

    i = 0;
    for (i; i < Screens.challengeKeys.length; i++) {
        this.challengeValues[Screens.challengeKeys[i]] = 0;
    }

    this.build();
};

JumpGame.prototype = Object.create(PIXI.Container.prototype);
JumpGame.prototype.constructor = JumpGame;

JumpGame.prototype.build = function () {
    //declare vars
    var i, self, platform, collectible, points, graphicKey, enemy;

    this.buildPlayer();

    this.addChild(this.colourBackground);
    this.addChild(this.tileBackground);
    this.addChild(this.boostBackgroundGraphic);
    this.addChild(this.boostOverlay);

    this.platformSpeedMultiplier = 50;
    this.platformShrinkMultiplier = 0.5;

    //for scope breaking
    self = this;
    //create keyboard events
    if (!CC.isMobile) {
        var targetWindow = window.parent || window;
        this.keyboardControlEventDown = targetWindow.addEventListener("keydown", this._keyDown.bind(this));
        this.keyboardControlEventUp = targetWindow.addEventListener("keyup", this._keyUp.bind(this));
    }
    else {
        var targetWindow = window.top;
        this.orientationControlEvent = targetWindow.addEventListener('deviceorientation', function (event) {
            self.controlVelocityGamma = event.gamma;
            CC.WebApp.current.screenObject.updateRotationText(event.gamma);
        });

        this.orientationChangedEvent = targetWindow.addEventListener('orientationchange', function (event) {
            var orientation = window.top.orientation;

            if (orientation === 180) {
                Screens.upsideDown = true;
            }
            else {
                Screens.upsideDown = false;
            }

            CC.WebApp.current.screenObject.updateOrientationText(orientation);
        });
    }

    if (!!this.difficultyNum) {
        this.enemyPlacement = this.json.enemy_placement.hard;
        this.platformPlacement = this.json.platform_placement.hard;
        this.collectiblePlacement = this.json.collectible_placement.hard;
    } else {
        this.enemyPlacement = this.json.enemy_placement.easy;
        this.platformPlacement = this.json.platform_placement.easy;
        this.collectiblePlacement = this.json.collectible_placement.easy;
    }

    //populate platformPool and collectiblePool;
    for (i = 0; i < this.collectibleCount; ++i) {
        collectible = new JumpGameCollectible(this.json.collectibles);
        this.collectiblePool.push(collectible);
        this.collectibleContainer.addChild(collectible);
    }

    for (i = 0; i < this.enemyCount; i += 1) {
        enemy = new JumpGameEnemy(this.json.enemies, this.showHitBoxes);
        this.enemyPool.push(enemy);
        this.enemyContainer.addChild(enemy);
    }

    for (i = 0; i < this.platformCount; ++i) {
        platform = new JumpGamePlatform(this.json.platforms);
        this.platformPool.push(platform);
        this.platformContainer.addChild(platform);
    }

    for (i = 0; i < this.pointsCount; ++i) {
        points = new JumpGamePoints(this.json.item_score_text);
        this.pointsPool.push(points);
        this.pointsContainer.addChild(points);
    }

    this.platformHitLayer.interactive = true;

    this.hitLayer.interactive = true;
    this.hitLayer.hitArea = new PIXI.Rectangle(-1000, -1000, 2000, 2000);

    this.hitLayer.mousedown = this.hitLayer.touchstart = function (event) {
        this.grabbed = true;
        self.mouseX = event.data.getLocalPosition(this).x;
    };

    this.hitLayer.mousemove = this.hitLayer.touchmove = function (event) {
        if (this.grabbed) {
            self.mouseX = event.data.getLocalPosition(this).x;
        }
    };

    this.hitLayer.mouseup = this.hitLayer.touchend = this.hitLayer.mouseupoutside = this.hitLayer.touchendoutside = function (event) {
        this.grabbed = false;
        self.leftKeyDown = false;
        self.rightKeyDown = false;
    };

    this.doubleJumpVelocity = this.json.jump_button.jump_velocity;
    this.doubleJumpAvailable = true;
    this.doubleJumpEffect = Widgets.createAsset(this.json.jump_effect_image);
    this.doubleJumpEffect.alpha = 0;

    this.platformActivatorAvailable = true;
    this.platformActivatorCooldown = 0;

    this.primaryAttackEffect = Widgets.createAsset(this.json.attack_effect.primary_image);
    this.primaryAttackEffect.x = -(this.player.width / 2);
    this.primaryAttackEffect.y = -(this.player.height / 2);
    this.primaryAttackEffect.alpha = 0;
    this.player.addChild(this.primaryAttackEffect);

    if (this.json.attack_effect.secondary_image) {
        this.secondaryAttackEffect = Widgets.createAsset(this.json.attack_effect.secondary_image);
        this.secondaryAttackEffect.x = this.primaryAttackEffect.x;
        this.secondaryAttackEffect.y = this.primaryAttackEffect.y;
        this.secondaryAttackEffect.alpha = 0;
        this.secondaryAttackEffect.scale.set(0);
        this.player.addChild(this.secondaryAttackEffect);
    }

    //build display tree;
    this.cameraContainer.addChild(this.platformContainer);
    this.cameraContainer.addChild(this.collectibleContainer);
    this.cameraContainer.addChild(this.enemyContainer);

    this.cameraContainer.addChild(this.doubleJumpEffect);

    if (this.charJson.boost_graphic) {
        this.boostGraphicArray = [];
        for (i = 0; i < this.playerBoostGraphicLength; i += 1) {
            this.boostGraphicArray.push(Widgets.createAsset(this.charJson.boost_graphic));
            this.boostGraphicArray[i].alpha = 1 - (i * (1 / this.playerBoostGraphicLength));
        }
    }

    if (this.boostGraphicArray) {
        for (graphicKey in this.boostGraphicArray) {
            this.cameraContainer.addChild(this.boostGraphicArray[graphicKey]);
        }
    }

    this.deathBackgroundGraphic = Widgets.createAsset(this.json.death_background_graphic);
    this.deathBackgroundGraphic.visible = false;

    this.bottomSquare = new PIXI.Graphics();
    this.bottomSquare.beginFill(this.json.death_background_colour);
    this.bottomSquare.drawRect(-1024 * 0.5, -1024 * 0.5, 1024, 1024);
    this.bottomSquare.endFill();
    this.bottomSquare.visible = false;
    this.addChild(this.bottomSquare);

    this.topSquare = new PIXI.Graphics();
    this.topSquare.beginFill(this.json.death_background_colour);
    this.topSquare.drawRect(-1024 * 0.5, -1024 * 0.5, 1024, 1024);
    this.topSquare.endFill();
    this.topSquare.visible = false;
    this.deathBackgroundGraphic.addChild(this.topSquare);

    this.leftSquare = new PIXI.Graphics();
    this.leftSquare.beginFill(this.json.death_background_colour);
    this.leftSquare.drawRect(-1024 * 0.5, -1024 * 0.5, 1024, 1024);
    this.leftSquare.endFill();
    this.leftSquare.visible = false;
    this.addChild(this.leftSquare);

    this.rightSquare = new PIXI.Graphics();
    this.rightSquare.beginFill(this.json.death_background_colour);
    this.rightSquare.drawRect(-1024 * 0.5, -1024 * 0.5, 1024, 1024);
    this.rightSquare.endFill();
    this.rightSquare.visible = false;
    this.addChild(this.rightSquare);

    this.deathBackgroundGraphic.scale.set(4);
    this.cameraContainer.addChild(this.deathBackgroundGraphic);
    this.cameraContainer.addChild(this.bottomSquare);
    this.cameraContainer.addChild(this.topSquare);
    this.cameraContainer.addChild(this.leftSquare);
    this.cameraContainer.addChild(this.rightSquare);

    this._deathBackgroundUpdate();

    var record = localStorage.getItem(Screens.json.localStorageName);
    if (record) {
        this.heightMarker = new PIXI.Container();
        this.heightMarker.y = -(record * this.heightUnit) - this.player.height / 2;
        this.heightMarker.recordHeight = record;
        this.heightMarker.beaten = false;

        this.heightMarker.strip = Widgets.createAsset(this.json.height_marker_image);
        this.heightMarker.addChild(this.heightMarker.strip);

        this.heightMarker.unit = Widgets.createAsset(Screens.json.ui.score_icon);
        this.heightMarker.addChild(this.heightMarker.unit);

        this.cameraContainer.addChild(this.heightMarker);
    }

    this.cameraContainer.addChild(this.player);
    this.cameraContainer.addChild(this.pointsContainer);

    this.addChild(this.cameraContainer);
    this.addChild(this.hitLayer);
    this.addChild(this.platformHitLayer);

    this.enemySound = sound.play(this.audioJson.enemy, 0, true);
    this.deadlyPlatformSound = sound.play(this.audioJson.dangerous_platform, 0, true);
    this.player.invincibleSound = undefined;

};

JumpGame.prototype.buildPlayer = function BuildPlayer() {

    this.charJson = this.json.characters[this.characterNum];

    this.player = new PIXI.Container();

    this.player.graphic = Widgets.createAsset(this.charJson);
    this.player.addChild(this.player.graphic);

    this.player.hitGraphic = new PIXI.Graphics();
    this.player.hitGraphic.lineStyle(4, 0x000000, 1);
    this.player.hitGraphic.beginFill(0x339966, 0.5);

    if (this.charJson.hit_box && this.charJson.hit_box.width &&
        this.charJson.hit_box.height) {

        this.player.hitGraphic.drawRect(
            this.charJson.hit_box.width * -0.5,
            this.charJson.hit_box.height * -0.5,
            this.charJson.hit_box.width,
            this.charJson.hit_box.height);

        if (this.charJson.hit_box.position) {
            this.player.hitGraphic.position = this.charJson.hit_box.position;
        }

    }
    else {
        this.player.hitGraphic.drawRect(
            this.player.graphic.width * -0.5,
            this.player.graphic.height * -0.5,
            this.player.graphic.width,
            this.player.graphic.height);
    }

    if (this.charJson.invincible_graphic) {
        this.player.invincibleGraphic = Widgets.createAsset(this.charJson.invincible_graphic);
        //this.player.invincibleGraphic.y = Math.lerp(this.player.height * 0.5, -this.player.height * 0.5, this.player.graphic.anchor.y);
        this.player.invincibleGraphic.y += ((this.player.invincibleGraphic.height - this.player.graphic.height) / 2);
        this.player.invincibleGraphic.alpha = 0;
        this.player.addChild(this.player.invincibleGraphic);
    }

    if (this.charJson.death_graphics) {
        this.player.deathGraphicLeft = Widgets.createAsset(this.charJson.death_graphics[1]);
        this.player.deathGraphicLeft.y = this.player.graphic.anchor.y;
        this.player.deathGraphicLeft.x -= 7;
        this.player.deathGraphicLeft.alpha = 0;
        this.player.addChild(this.player.deathGraphicLeft);

        this.player.deathGraphicRight = Widgets.createAsset(this.charJson.death_graphics[2]);
        this.player.deathGraphicRight.y = this.player.graphic.anchor.y;
        this.player.deathGraphicRight.x += 7;
        this.player.deathGraphicRight.alpha = 0;
        this.player.addChild(this.player.deathGraphicRight);

        this.player.deathGraphic = Widgets.createAsset(this.charJson.death_graphics[0]);
        this.player.deathGraphic.y = this.player.graphic.anchor.y;
        this.player.deathGraphic.alpha = 0;
        this.player.addChild(this.player.deathGraphic);
    }

    this.player.hitGraphic.endFill();
    this.player.hitGraphic.visible = !!this.showHitBoxes;
    this.player.addChild(this.player.hitGraphic);

    this.player.respawning = false;
    this.player.dead = false;

};

JumpGame.prototype.checkHitSquare = function CheckHitSquare(aPos, aSquare, bPos, bSquare) {

    var aLeft = aPos.x + (aSquare.position.x * aPos.scale.x) - (aSquare.width * 0.5);
    var aRight = aPos.x + (aSquare.position.x * aPos.scale.x) + (aSquare.width * 0.5);
    var aTop = aPos.y + (aSquare.position.y * aPos.scale.y) - (aSquare.height * 0.5);
    var aBottom = aPos.y + (aSquare.position.y * aPos.scale.y) + (aSquare.height * 0.5);

    var bLeft = bPos.x + (bSquare.position.x * bPos.scale.x) - (bSquare.width * 0.5);
    var bRight = bPos.x + (bSquare.position.x * bPos.scale.x) + (bSquare.width * 0.5);
    var bTop = bPos.y + (bSquare.position.y * bPos.scale.y) - (bSquare.height * 0.5);
    var bBottom = bPos.y + (bSquare.position.y * bPos.scale.y) + (bSquare.height * 0.5);

    if (aLeft >= bRight || aTop >= bBottom ||
        aRight <= bLeft || aBottom <= bTop) {
        return false;
    }
    else {
        return true;
    }

};

JumpGame.prototype.probabilityCheck = function (entities) {

    var i, range, index, length, total, value, indexesIncluded;
    length = entities.length;
    indexesIncluded = [];
    total = 0;
    index = -1;

    for (i = 0; i < length; i += 1) {
        if (this.heightScore >= entities[i].start_height) {
            total += entities[i].type_frequency;
            indexesIncluded.push(i);
        }
    }

    length = indexesIncluded.length;
    value = Math.random() * total;
    range = 0;
    for (i = 0; i < length; ++i) {
        range += entities[indexesIncluded[i]].type_frequency;
        if (value < range) {
            index = indexesIncluded[i];
            break;
        }
    }

    if (index !== -1) {
        return entities[index].index;
    }
    else {
        return index;
    }

};

JumpGame.prototype.unbuild = function () {
    if (!CC.isMobile) {
        var targetWindow = window.parent || window;
        targetWindow.removeEventListener("keydown", this.keyboardControlEventDown);
        targetWindow.removeEventListener("keyup", this.keyboardControlEventUp);
    }
    else {
        document.removeEventListener('deviceorientation', this.orientationControlEvent);
        document.removeEventListener('orientationchange', this.orientationChangedEvent);
    }
};

JumpGame.prototype.genPlatform = function (first) {

    var objectSpawnProb, chanceValue, object;

    var xPosition = (Math.random() - 0.5) * 400 * (!first);
    var yPosition = this.currentPlatformGenHeight - 100;
    if (this.lastPlatform) {
        yPosition = this.currentPlatformGenHeight - this.lastPlatform.nextPlatformDistance;
    }

    var type;
    if (first) {
        type = 0;
    } else {
        type = this.probabilityCheck(this.platformPlacement.platforms);
        if (type === -1) {
            type = 0;
        }
    }
    this.lastPlatform = this.addPlatform(xPosition, yPosition, type);

    objectSpawnProb = Math.random();
    chanceValue = this.collectiblePlacement.general_frequency;
    if (objectSpawnProb < chanceValue) {
        object = this.addCollectible(this.lastPlatform);
    }

    if (object === undefined) {
        objectSpawnProb = Math.random();
        chanceValue = this.enemyPlacement.general_frequency;
        if (objectSpawnProb < chanceValue) {
            object = this.addEnemy(this.lastPlatform);
        }
    }

    if ((this.lastPlatform.destroyable || this.lastPlatform.grappleable) && object) {
        object.hide();
    }
    this.currentPlatformGenHeight = yPosition;
};

JumpGame.prototype._keyDown = function (event) {
    if (!this.player.dead) {
        switch (event.keyCode) {
            case 32://space
                event.preventDefault();
                if (CC.WebApp.current.screenObject.jumpButton.interactive) {
                    CC.WebApp.current.screenObject.jumpButton.click();
                }
                break;
            case 37://left
                event.preventDefault();
                this.leftKeyDown = true;
                break;
            case 38://up, just stop it having it's default effect
                event.preventDefault();
                break;
            case 39://right
                event.preventDefault();
                this.rightKeyDown = true;
                break;
            case 40://down, just stop it having it's default effect
                event.preventDefault();
                break;
            case 88://x
                event.preventDefault();
                if (CC.WebApp.current.screenObject.attackButton.interactive) {
                    CC.WebApp.current.screenObject.attackButton.click();
                }
                break;
            case 90://z
                event.preventDefault();
                if (CC.WebApp.current.screenObject.platformButton.interactive) {
                    CC.WebApp.current.screenObject.platformButton.click();
                }
                this.activateOnScreenCreatablePlatforms();
                break;
        }
    }
};

JumpGame.prototype._keyUp = function (event) {
    switch (event.keyCode) {
        case 37://left
            event.preventDefault();
            this.leftKeyDown = false;
            break;
        case 39://right
            event.preventDefault();
            this.rightKeyDown = false;
            break;
    }

};

JumpGame.prototype.start = function () {
    this.currentPlatformGenHeight = 200;
    this.playing = true;
    for (var i = 0; i < 3; ++i) {
        this.genPlatform(!i);
    }
};

JumpGame.prototype.pause = function () {

};

JumpGame.prototype.addPlatform = function (x, y, type) {
    //find a free platform ie one that is not currently visible
    var i, platform, length, newBoxIndex;
    length = this.platformCount;
    for (i = 0; i < length; ++i) {
        platform = this.platformPool[i];
        if (!platform.visible) {
            i = length;
        }
    }
    if (platform) {
        platform.show(x, y, type);
        if (platform.waitingToBeCreated) {
            this.platformHitBoxList.push(new PIXI.Container());
            newBoxIndex = this.platformHitBoxList.length - 1;
            this.platformHitBoxList[newBoxIndex].interactive = true;
            this.platformHitBoxList[newBoxIndex].hitArea = new PIXI.Rectangle(platform.platformWidth * -0.5, platform.platformHeight * -0.5, platform.platformWidth, platform.platformHeight);
            console.log(platform.platformWidth + " " + platform.platformHeight);

            this.platformHitBoxList[newBoxIndex].x = x;
            this.platformHitBoxList[newBoxIndex].y = y;
            this.platformHitBoxList[newBoxIndex].initialY = y;
            this.platformHitBoxList[newBoxIndex].platform = platform;
            this.platformHitBoxList[newBoxIndex].mousedown = platform.inputOn.bind(platform);
            this.platformHitBoxList[newBoxIndex].touchstart = platform.inputOn.bind(platform);
            this.platformHitLayer.addChild(this.platformHitBoxList[newBoxIndex]);
        }
    }
    return platform;
};

JumpGame.prototype.addCollectible = function (platform) {
    //find a free collectible ie one that is not currently visible
    var i, collectible, length, type;
    length = this.collectibleCount;
    for (i = 0; i < length; ++i) {
        if (!this.collectiblePool[i].visible) {
            collectible = this.collectiblePool[i];
            i = length;
        }
    }

    if (collectible) {

        type = this.probabilityCheck(this.collectiblePlacement.collectibles);

        if (type !== -1) {
            if (this.json.collectibles[type].extra_life) {
                if (this.extraLifeVisible || this.hasExtraLife) {
                    type = -1;
                }
                else {
                    this.extraLifeVisible = true;
                }
            }
            else if (this.json.collectibles[type].invincible_time) {
                if (this.invincibilityVisible || this.invincibilitySpawnDelay > 0) {
                    type = -1;
                }
                else {
                    this.invincibilityVisible = true;
                }
            }
        }

        if (type !== -1) {
            collectible.show(platform, type);
        }

    }
    return collectible;
};

JumpGame.prototype.addEnemy = function AddEnemy(platform) {
    //find a free platform ie one that is not currently visible
    var i, enemy, length, type;
    length = this.enemyCount;
    for (i = 0; i < length; ++i) {
        if (!this.enemyPool[i].visible) {
            enemy = this.enemyPool[i];
            i = length;
        }
    }

    if (enemy) {
        type = this.probabilityCheck(this.enemyPlacement.enemies);

        if (type !== -1) {
            enemy.show(platform, type);
        }
    }
    return enemy;
};

JumpGame.prototype.showPoints = function (x, y, score) {

    this.score += score;

    //find a free points ie one that is not currently visible
    var i, points, length;
    length = this.pointsCount;
    for (i = 0; i < length; ++i) {
        points = this.pointsPool[i];
        if (!points.visible) {
            i = length;
        }
    }
    if (points) {
        points.show(x, y, score);
    }
};

JumpGame.prototype.end = function () {

    var i, storageString;

    for (i = 0; i < Screens.challengeKeys.length; i += 1) {
        storageString = Screens.json.localStorageName + "_" + Screens.challengeKeys[i] + "_add";
        localStorage.setItem(storageString, this.challengeValues[Screens.challengeKeys[i]]);
    }

    this.unbuild();
    this.gameEndFunc(this.heightScore);
};

JumpGame.prototype.doRespawnTween = function doRespawnTween() {

    var i, targetY;

    this.player.x = 0;
    this.player.y = (-this.cameraContainer.y) + ((CC.WebApp.current.screenHeight * 0.5) + (this.player.height * this.player.graphic.anchor.y));

    targetY = this.player.y - 800;
    if (this.player.deathGraphic) {
        this.player.deathGraphic.alpha = 0;
        this.player.deathGraphicLeft.alpha = 0;
        this.player.deathGraphicRight.alpha = 0;
    }

    if (this.boostGraphicArray) {
        for (i = 0; i < this.boostGraphicArray.length; i += 1) {
            this.boostGraphicArray[i].alpha = 0;
        }
    }

    this.player.graphic.alpha = 0.5;
    this.invincibleTime = 3;

    TweenLite.to(this.player.position, 1.0, {
        y: targetY,
        ease: Power2.easeOut,
        delay: 1.0,
        onComplete: function () {
            this.player.respawning = false;
            this.player.graphic.alpha = 1;
            this.playerVelocity = 0;
        }.bind(this)
    });

};

JumpGame.prototype.update = function (delta) {

    var i;

    this.controlUpdate(delta);

    this.heightScoreUpdate(delta);

    if (!this.player.dead && !this.grappling) {

        this.movementUpdate(delta);

        this.platformHitBoxUpdate(delta);

        this.platformUpdate(delta);

        this.attackUpdate(delta);

        this.collectibleUpdate(delta);

        this.enemyUpdate(delta);
    }

    if (this.platformActivatorCooldown > 0) {
        this.platformActivatorCooldown -= delta;
        if (this.platformActivatorCooldown <= 0) {
            this.platformActivatorCooldown = 0;
            this.platformActivatorAvailable = true;
            CC.WebApp.current.screenObject.setPlatformButtonActive(this.platformActivatorAvailable);
        }
    }

    //keep adding platforms until you are far enough away from the player
    while (this.playing && this.currentPlatformGenHeight > this.player.position.y + this.platformGenOffset) {
        this.genPlatform();
    }
    //detect player death
    if (!this.player.dead && !this.player.respawning && !this.boosting) {
        if (this.player.position.y > (-this.cameraContainer.y) + ((CC.WebApp.current.screenHeight * 0.5) + (this.player.height * this.player.graphic.anchor.y))) {

            this.invincibleTime = 0;
            this.player.invincibleGraphic.alpha = 0;
            if (this.player.invincibleSound) {
                sound.stop(this.audioJson.invincible);
            }

            if (!this.hasExtraLife) {
                this.player.dead = true;
                this.player.respawning = false;
                this.player.graphic.alpha = 0;
                this.player.x = 0;
                this.player.y = this.cameraTarget.y + (CC.WebApp.current.screenHeight * 0.5);
                this._startDeathBackground(true);
            }
            else {
                this.player.respawning = true;
                this.player.dead = false;
                this.hasExtraLife = !this.hasExtraLife;
                this.doubleJumpAvailable = true;
                CC.WebApp.current.screenObject.setJumpButtonActive(this.doubleJumpAvailable);
                CC.WebApp.current.screenObject.setExtraLifeAvailable(this.hasExtraLife);
                this.doRespawnTween();
            }
        }
    }

    if (!this.player.dead) {
        //camera movement
        if (!this.boosting) {
            this.cameraTarget.y = Math.min(this.player.position.y, this.cameraTarget.y);
            this.cameraContainer.position.y = Math.lerp(-this.cameraTarget.y + 200, this.cameraContainer.position.y, 0.9);
        }

        this.tileBackground.position.y = (this.cameraContainer.position.y * 0.2) % this.tileBackground.tileHeight;
        this.tileBackground.position.y -= 568;

        this.boostBackgroundGraphic.position.y = this.tileBackground.position.y;
    }
    else {
        this._deathBackgroundUpdate();
        this._deadPlayerUpdate(delta);
    }

    if (this.boostGraphicArray) {
        this.boostGraphicUpdate(delta);
    }

    if (this.invincibleTime > 0) {
        this.invincibleTime -= delta;

        if (this.invincibleTime <= 0) {
            if (this.player.invincibleGraphic) {
                this.player.invincibleGraphic.alpha = 0;
            }

            if (this.player.invincibleSound) {
                sound.stop(this.audioJson.invincible);
            }

            this.player.graphic.alpha = 1;

            if (this.boostGraphicArray) {
                for (i = 0; i < this.boostGraphicArray.length; i += 1) {
                    this.boostGraphicArray[i].alpha = 0;
                }
            }
        }
    }

    if (this.invincibilitySpawnDelay > 0) {
        this.invincibilitySpawnDelay -= delta;
    }

    if (this.boosting) {
        this.boostOverlay.offset += 2000 * delta;
        this.boostOverlay.position.y = this.boostOverlay.offset % this.boostOverlay.tileHeight;
    }

};

JumpGame.prototype.controlUpdate = function ControlUpdate(delta) {

    if (this.hitLayer.grabbed) {
        if (this.mouseX - this.player.position.x < 0) {
            this.rightKeyDown = false;
            this.leftKeyDown = true;
        }
        else {
            this.leftKeyDown = false;
            this.rightKeyDown = true;
        }
    }

    if (!this.player.dead) {
        //going left;
        if (this.leftKeyDown && !this.rightKeyDown) {
            this.leaningEaseOff = 0;
            //this.player.x -= this.controlSpeed * delta;
            this.controlVelocity -= this.controlSpeed * delta * 10;
            this.player.scale.x = 1;
        }

        //going right
        if (this.rightKeyDown && !this.leftKeyDown) {
            this.leaningEaseOff = 0;
            //this.player.x += this.controlSpeed * delta;
            this.controlVelocity += this.controlSpeed * delta * 10;
            this.player.scale.x = -1;
        }

        if (CC.isMobile && !this.rightKeyDown && !this.leftKeyDown) {
            this.leaningEaseOff = Math.min(this.leaningEaseOff += delta, 1);

            if (!Screens.upsideDown) {
                this.controlVelocity = this.controlVelocityGamma * delta * 1000 * this.leaningEaseOff;
            }
            else {
                this.controlVelocity = -this.controlVelocityGamma * delta * 1000 * this.leaningEaseOff;
            }


            if (Math.abs(this.controlVelocity) > 10) {
                if (this.controlVelocity > 0) {

                    this.player.scale.x = -1;
                }
                else {
                    this.player.scale.x = 1;

                }
            }
        }
    }

};

JumpGame.prototype.heightScoreUpdate = function HeightScoreUpdate(delta) {

    if (this.player.position.y < 0) {
        var currentHeight = Math.floor(Math.abs(this.player.position.y) / this.heightUnit);

        if (currentHeight > this.heightScore && !this.player.dead) {
            this.heightScore = currentHeight;
            CC.WebApp.current.screenObject.updatePointsText(this.heightScore);
            this.challengeValues[Screens.heightChallengeKey] = this.heightScore;
        }
    }

    if (this.heightMarker !== undefined && !this.heightMarker.beaten) {
        if (this.heightScore > this.heightMarker.recordHeight) {
            this.heightMarker.beaten = true;
            TweenLite.to(this.heightMarker, 0.5, {alpha: 0});
            TweenLite.to(this.heightMarker.scale, 0.5, {x: 2, y: 2});
        }
    }

};

JumpGame.prototype.movementUpdate = function MovementUpdate(delta) {

    this.playerVelocity += this.currentGravity * delta;
    this.player.oldy = this.player.position.y;
    this.controlVelocity *= 0.95;

    this.player.position.x += this.controlVelocity * delta;

    if (!this.player.respawning) {
        this.player.position.y += this.playerVelocity * delta;
    }

    this.player.position.x = Math.max(this.player.position.x, this.playerWidthBounds * -0.5);
    this.player.position.x = Math.min(this.player.position.x, this.playerWidthBounds * 0.5);

};

JumpGame.prototype.platformHitBoxUpdate = function PlatformHitBoxUpdate(delta) {

    var i;

    for (i = this.platformHitBoxList.length - 1; i >= 0; i -= 1) {
        this.platformHitBoxList[i].position.y = this.platformHitBoxList[i].initialY + this.cameraContainer.position.y;

        if (this.platformHitBoxList[i].platform.shrinkSpeed) {
            this.platformHitBoxList[i].scale.set(this.platformHitBoxList[i].platform.activeGraphic.scale.x);
        }

        if (!this.platformHitBoxList[i].platform.waitingToBeCreated ||
            !this.platformHitBoxList[i].platform.visible) {
            this.platformHitLayer.removeChild(this.platformHitBoxList[i]);
            this.platformHitBoxList.splice(i, 1);
        }
    }

};

JumpGame.prototype.platformUpdate = function PlatformUpdate(delta) {

    var i, platform, shrink, distance, closestDistance;

    //Platform Update
    for (i = 0; i < this.platformCount; ++i) {
        platform = this.platformPool[i];
        //check if the platform is visible and has been hit;
        if (platform.visible) {

            if (!this.boosting) {
                if (platform.checkHit(this.player) && !platform.waitingToBeCreated) {

                    if (!platform.grappleable) {
                        //to keep things fair set the player height to the platform
                        this.player.position.y = platform.topY;
                        this.playerVelocity = platform.jumpVelocity;
                        sound.play(this.audioJson.jump);

                        //bump the platform
                        this.dropLimit = Math.min(this.dropLimit, platform.position.y);
                        platform.hit();

                        this.doubleJumpAvailable = true;
                        CC.WebApp.current.screenObject.setJumpButtonActive(this.doubleJumpAvailable);

                        this.currentGravity = this.originalGravity;

                        if (platform.deadly && this.invincibleTime <= 0) {
                            if (this.hasExtraLife) {
                                this.player.dead = false;
                                this.hasExtraLife = !this.hasExtraLife;
                                CC.WebApp.current.screenObject.setExtraLifeAvailable(this.hasExtraLife);
                                if (this.player.invincibleGraphic) {
                                    this.player.invincibleGraphic.alpha = 1;
                                    TweenLite.to(this.player.invincibleGraphic, 1.0, {alpha: 0});
                                }
                            }
                            else {
                                this.playerKilled();
                            }
                        }
                    }
                    else {
                        this.grappling = true;
                        platform.hit();
                        TweenLite.killTweensOf(this.player);
                        TweenLite.killTweensOf(this.player.position);
                        TweenLite.killTweensOf(this.player.graphic);
                        this.player.respawning = false;
                        sound.play(this.audioJson.grapple);
                        TweenLite.to(this.player.position, 0.5, {
                            x: platform.position.x,
                            y: platform.position.y + (this.player.graphic.height * (this.player.graphic.anchor.y - 0.5)),
                            onComplete: function (platform, that) {
                                return function () {
                                    that.playerVelocity = platform.jumpVelocity;
                                    that.dropLimit = Math.min(that.dropLimit, platform.position.y);
                                    that.doubleJumpAvailable = true;
                                    CC.WebApp.current.screenObject.setJumpButtonActive(that.doubleJumpAvailable);
                                    that.currentGravity = that.originalGravity;
                                    that.grappling = false;
                                }
                            }(platform, this)
                        });
                    }
                }
            }

            //if the platform has a move speed, move it
            if (platform.moveSpeed) {
                platform.position.x += ((this.platformSpeedMultiplier * delta) * platform.moveSpeed) * platform.moveDirection;
                if (platform.moveDirection > 0) {
                    if (((platform.position.x + (platform.platformWidth / 2)) > (CC.WebApp.current.screenWidth / 2))) {
                        platform.moveDirection *= -1;
                    }
                }
                else {
                    if (((platform.position.x - (platform.platformWidth / 2)) < -(CC.WebApp.current.screenWidth / 2))) {
                        platform.moveDirection *= -1;
                    }
                }
            }

            //if the plaform has a shrink speed, shrink it
            if (platform.shrinkSpeed) {
                shrink = platform.activeGraphic.scale.x;
                shrink += delta * this.platformShrinkMultiplier * platform.shrinkSpeed * platform.shrinkDirection;
                platform.activeGraphic.scale.set(shrink);

                if (platform.activeGraphic.scale.x < 0.2 ||
                    platform.activeGraphic.scale.x > 1) {
                    platform.shrinkDirection *= -1;
                    var scale;
                    if (platform.activeGraphic.scale.x < 0.2) {
                        scale = 0.2;
                    } else {
                        scale = 1;
                    }
                    platform.switchActiveGraphicAndMakeItVisible();
                    platform.activeGraphic.scale.set(scale);
                }
            }

            //if the platform is out of sight remove it;
            if (this.ignoringDropLimit) {
                if (platform.position.y > -this.cameraContainer.y + (CC.WebApp.current.screenHeight * 0.5 + platform.halfHeight)) {
                    platform.hide();
                }
            }
            else {
                if (platform.position.y > this.dropLimit + CC.WebApp.current.screenHeight * 0.5 + 100) {
                    platform.hide();
                }
            }

            if (platform.deadly) {
                distance = Math.abs((this.player.position.y - (this.player.graphic.height * 0.5)) - platform.position.y);
                if (closestDistance === undefined || distance < closestDistance) {
                    closestDistance = distance;
                }
            }
        }
    }

    if (this.deadlyPlatformSound) {
        if (closestDistance !== undefined) {
            this.deadlyPlatformSound.volume = Math.value(900, 0, closestDistance);
        }
        else {
            this.deadlyPlatformSound.volume = 0;
        }
    }

};

JumpGame.prototype.attackUpdate = function AttackUpdate(delta) {

    var i, enemy;

    if (this.primaryAttackEffect.alpha > 0) {
        for (i = 0; i < this.enemyCount; i += 1) {
            enemy = this.enemyPool[i];
            if (enemy.visible && !enemy.invincible && !enemy.destroyed) {
                if (this.checkHitSquare(this.player, this.primaryAttackEffect, enemy, enemy.hitGraphic)) {
                    enemy.hide();
                    sound.play(this.audioJson.enemy_destroyed, 1);
                    this.challengeValues[Screens.defeatedChallengeKey] += 1;
                }
            }
        }
    }

};

JumpGame.prototype.collectibleUpdate = function CollectibleUpdate(delta) {

    var i, collectible, hide;

    for (i = 0; i < this.collectibleCount; ++i) {
        hide = false;
        collectible = this.collectiblePool[i];

        //check if the collectable is visible and has been hit;
        if (collectible.canBeCollected) {
            if (!this.boosting && this.checkHitSquare(this.player, this.player.hitGraphic, collectible, collectible.graphic)) {
                collectible.collect();
                this.challengeValues[Screens.collectiblesChallengeKey] += 1;

                if (collectible.boostDistance) {
                    sound.play(this.audioJson.boost);
                    this.boostCollected(collectible);
                }
                else if (collectible.invincibleTime) {
                    sound.play(this.audioJson.collect);
                    this.invincibleTime = collectible.invincibleTime;
                    this.player.invincibleSound = sound.play(this.audioJson.invincible, 1, true);
                    this.player.respawning = false;
                    this.invincibilityVisible = false;
                    this.invincibilitySpawnDelay = 20;
                    if (this.player.invincibleGraphic) {
                        this.player.graphic.alpha = 0;
                        this.player.invincibleGraphic.alpha = 1;
                    }
                }
                else if (collectible.extraLife) {
                    sound.play(this.audioJson.collect);
                    if (!this.hasExtraLife) {
                        this.hasExtraLife = true;
                        this.extraLifeVisible = false;
                        CC.WebApp.current.screenObject.setExtraLifeAvailable(this.hasExtraLife);
                    }
                }
            }

            //set collectible position based on target platform
            collectible.position.x = collectible.targetPlatform.position.x;
            collectible.position.y = collectible.targetPlatform.position.y;
            collectible.position.y -= collectible.targetPlatform.activeGraphic.height * collectible.graphic.anchor.y;
            collectible.position.y -= collectible.graphic.height * collectible.graphic.anchor.y;

            //if the collectable is out of sight remove it;
            if (collectible.position.y > -this.cameraContainer.y + (CC.WebApp.current.screenHeight * 0.5 + collectible.halfHeight)) {
                hide = true;
            }

            if (hide) {
                collectible.hide();
                if (collectible.extraLife) {
                    this.extraLifeVisible = false;
                }
                else if (collectible.invincibleTime) {
                    this.invincibilityVisible = false;
                    this.invincibilitySpawnDelay = 20;
                }
            }
        }
    }

};

JumpGame.prototype.enemyUpdate = function EnemyUpdate(delta) {

    var i, enemy, distance, closestIndex = -1, closestDistance = -1, soundDistance;

    for (i = 0; i < this.enemyCount; i += 1) {
        enemy = this.enemyPool[i];

        if (enemy.visible && !enemy.destroyed) {

            distance = (this.player.position.y - this.player.graphic.height) - enemy.position.y;

            if (closestDistance === -1 || (distance < closestDistance && distance > 0)) {
                closestDistance = distance;
                closestIndex = i;
            }

            distance = Math.abs(distance);

            if (soundDistance === undefined || (distance < soundDistance)) {
                soundDistance = distance;
            }

            var positionAndDimensions = {
                x: this.player.position.x,
                y: this.player.position.y,
                width: this.player.graphic.width,
                height: this.player.graphic.height,
                anchor: this.player.graphic.anchor
            };

            if (this.checkHitSquare(this.player, this.player.hitGraphic, enemy, enemy.hitGraphic) && !this.boosting) {
                if (this.invincibleTime <= 0) {
                    if (this.hasExtraLife) {
                        this.player.dead = false;
                        this.hasExtraLife = !this.hasExtraLife;
                        CC.WebApp.current.screenObject.setExtraLifeAvailable(this.hasExtraLife);
                        sound.play(this.audioJson.enemy_destroyed, 1);
                        enemy.hide();
                        if (this.player.invincibleGraphic) {
                            this.player.invincibleGraphic.alpha = 1;
                            TweenLite.to(this.player.invincibleGraphic, 1.0, {alpha: 0});
                        }
                    }
                    else {
                        this.playerKilled();
                    }
                }
                else if (!this.player.respawning) {
                    enemy.hide();
                }
            }


            //set enemy position based on target platform
            enemy.position.x = enemy.targetPlatform.position.x;
            enemy.position.y = enemy.targetPlatform.y - (enemy.graphic.height * enemy.graphic.anchor.y);

            //if the enemy is out of sight remove it
            if (this.ignoringDropLimit) {
                if (enemy.position.y > -this.cameraContainer.y + (CC.WebApp.current.screenHeight * 0.5 + enemy.halfHeight)) {
                    enemy.hide();
                }
            }
            else {
                if (enemy.position.y > this.dropLimit + CC.WebApp.current.screenHeight * 0.5 + 100) {
                    enemy.hide();
                }
            }
        }
    }

    if (closestDistance !== -1 && closestDistance < 900 && closestDistance > 300) {
        this.closestIndex = closestIndex;
        this.closestEnemy = this.enemyPool[closestIndex];
        this.closestEnemy.distanceToPlayer = closestDistance;
    }
    else {
        this.closestIndex = undefined;
        this.closestEnemy = undefined;
    }

    if (this.enemySound) {
        if (soundDistance !== undefined) {
            this.enemySound.volume = Math.value(900, 0, closestDistance);
        }
        else {
            this.enemySound.volume = 0;
        }
    }

};

JumpGame.prototype.boostGraphicUpdate = function BoostGraphicUpdate(delta) {

    var i;

    for (i = 0; i < this.boostGraphicArray.length; i += 1) {

        if (this.player.dead || !this.boosting) {
            this.boostGraphicArray[i].position.x = this.player.position.x;
            this.boostGraphicArray[i].position.y = this.player.position.y;
        }
        else {
            this.boostGraphicArray[i].position.x = Math.lerp(this.player.position.x, this.boostGraphicArray[i].position.x, i / this.boostGraphicArray.length);
            this.boostGraphicArray[i].position.y = this.player.position.y + (((i + 1) * 40) * this.boostTweenValue);
        }

        this.boostGraphicArray[i].scale.set(this.player.scale.x, this.player.scale.y);
    }

};

JumpGame.prototype.boostCollected = function BoostCollected(collectible) {

    var fadeTime, endDistance;

    this.boosting = true;
    this.ignoringDropLimit = true;
    this.playerVelocity = 0;
    this.boostTweenValue = 0;

    this.currentGravity = this.boostGravity;
    if (this.boostBackgroundGraphic) {
        fadeTime = collectible.boostTime * 0.35;
        TweenLite.to(this.boostBackgroundGraphic, fadeTime, {alpha: 1});
        TweenLite.to(this.boostBackgroundGraphic, fadeTime, {alpha: 0, delay: collectible.boostTime - fadeTime});
    }

    endDistance = this.player.position.y - (collectible.boostDistance * this.heightUnit);

    TweenLite.to(this, collectible.boostTime * 0.5, {boostTweenValue: 1});
    TweenLite.to(this, collectible.boostTime * 0.5, {boostTweenValue: 0, delay: collectible.boostTime * 0.5});

    TweenLite.to(this.cameraContainer.position, collectible.boostTime, {
        y: -(endDistance - 180),
        ease: Power2.easeOut
    });

    TweenLite.to(this.player.position, collectible.boostTime, {
        y: endDistance,
        ease: Power2.easeOut,
        onComplete: this.boostCompleted.bind(this)
    });

    TweenLite.to(this.boostOverlay, collectible.boostTime / 5, {
        alpha: 1,
        tween: Power2.easeOut
    });

    TweenLite.to(this.boostOverlay, collectible.boostTime / 5, {
        alpha: 0,
        delay: (collectible.boostTime / 5) * 3,
        tween: Power2.easeOut
    });

};

JumpGame.prototype.boostCompleted = function BoostCompleted() {

    this.boosting = false;
    this.currentGravity = this.originalGravity;
    this.ignoringDropLimit = false;

};

JumpGame.prototype.jumpPressed = function JumpPressed() {
    if (this.doubleJumpAvailable && !this.boosting) {
        this.doubleJumpAvailable = false;
        this.playerVelocity = this.doubleJumpVelocity;
        CC.WebApp.current.screenObject.setJumpButtonActive(this.doubleJumpAvailable);

        this.doubleJumpEffect.x = this.player.x;
        this.doubleJumpEffect.y = this.player.y;
        this.doubleJumpEffect.alpha = 1;
        TweenLite.to(this.doubleJumpEffect, 0.5, {alpha: 0});
        sound.play(this.audioJson.double_jump, 1);
    }
};

JumpGame.prototype.attackPressed = function AttackPressed() {
    if (!this.boosting) {
        this.primaryAttackEffect.alpha = 1;

        if (this.playerVelocity < -200) {
            this.playerVelocity -= 200;
        }
        else {
            this.playerVelocity = -200;
        }

        this.controlVelocity += 200 * this.player.scale.x;

        sound.play(this.audioJson.attack, 1, false);

        TweenLite.to(this.primaryAttackEffect, 0.5, {alpha: 0});

        if (this.secondaryAttackEffect) {

            TweenLite.to(this.secondaryAttackEffect, 0.4, {alpha: 1});
            TweenLite.to(this.secondaryAttackEffect, 0.4, {
                alpha: 0,
                delay: 0.5
            });

            TweenLite.to(this.secondaryAttackEffect.scale, 0.8, {
                x: 2,
                y: 2,
                onComplete: function () {
                    this.scale.set(0);
                }.bind(this.secondaryAttackEffect)
            });
        }

        CC.WebApp.current.screenObject.startCooldownForAttackButton();
    }
};

JumpGame.prototype.playerKilled = function PlayerKilled() {
    if (!this.player.dead) {
        this.player.dead = true;
        sound.play(this.audioJson.hit_obstacle);
        if (this.player.deathGraphic) {
            this.player.deathGraphic.alpha = 1;
            this.player.deathGraphicLeft.alpha = 1;
            this.player.deathGraphicRight.alpha = 1;
            this.player.graphic.alpha = 0;
            this.player.invincibleGraphic.alpha = 0;
        }
        this._startDeathBackground();

    }
};

JumpGame.prototype._startDeathBackground = function StartDeathBackground(killedOffScreen) {

    var i, anchorXDif, anchorYDif, delay;

    if (this.boostGraphicArray) {
        for (i = 0; i < this.boostGraphicArray.length; i += 1) {
            this.boostGraphicArray[i].alpha = 0;
        }
    }

    delay = killedOffScreen ? 0 : 1;

    this.deathBackgroundGraphic.visible = true;
    this.bottomSquare.visible = true;
    this.topSquare.visible = true;
    this.leftSquare.visible = true;
    this.rightSquare.visible = true;

    anchorXDif = 0.5 - this.player.deathGraphic.anchor.x;
    anchorYDif = 0.5 - this.player.deathGraphic.anchor.y;

    this.deathBackgroundGraphic.x = this.player.x + (this.player.deathGraphic.width * anchorXDif);
    this.deathBackgroundGraphic.y = this.player.y + (this.player.deathGraphic.height * anchorYDif);

    TweenLite.to(this.deathBackgroundGraphic.scale, 1.5, {
        x: 0,
        y: 0,
        delay: delay,
        onStart: function () {
            sound.play(this.audioJson.game_over, 1);
        }.bind(this),
        onComplete: this.end.bind(this)
    });

};

JumpGame.prototype._deathBackgroundUpdate = function DeathBackgroundUpdate() {

    //Position each of the squares used to black out the background at the appropriate side of the central graphic
    this.bottomSquare.position.x = this.deathBackgroundGraphic.x;
    this.bottomSquare.position.y = this.deathBackgroundGraphic.position.y;
    this.bottomSquare.position.y += -(this.deathBackgroundGraphic.height / 2) - 512;

    this.topSquare.position.x = this.deathBackgroundGraphic.x;
    this.topSquare.position.y = this.deathBackgroundGraphic.position.y;
    this.topSquare.position.y += (this.deathBackgroundGraphic.height / 2) + 512;

    this.leftSquare.position.y = this.deathBackgroundGraphic.y;
    this.leftSquare.position.x = this.deathBackgroundGraphic.position.x;
    this.leftSquare.position.x += -(this.deathBackgroundGraphic.width / 2) - 512;

    this.rightSquare.position.y = this.deathBackgroundGraphic.y;
    this.rightSquare.position.x = this.deathBackgroundGraphic.position.x;
    this.rightSquare.position.x += (this.deathBackgroundGraphic.width / 2) + 512;

};

JumpGame.prototype._deadPlayerUpdate = function DeadPlayerUpdate(delta) {

    this.playerDeathGraphicTimer += delta;

    if (this.playerDeathGraphicTimer > 0.025) {
        if (!this.playerDeathGraphicSwitch) {
            this.player.deathGraphicLeft.position.x += 2;
            this.player.deathGraphicRight.position.x -= 2;
        }
        else {
            this.player.deathGraphicRight.position.x += 2;
            this.player.deathGraphicLeft.position.x -= 2;
        }

        this.playerDeathGraphicSwitch = !this.playerDeathGraphicSwitch;
        this.playerDeathGraphicTimer = 0;
    }

};

JumpGame.prototype.activateOnScreenCreatablePlatforms = function ActivateOnScreenCreatablePlatforms() {

    if (this.platformActivatorAvailable && !this.boosting) {
        this.platformActivatorAvailable = false;
        this.platformActivatorCooldown = 1;
        CC.WebApp.current.screenObject.setPlatformButtonActive(this.platformActivatorAvailable);

        var i, platform;

        //Platform Update
        for (i = 0; i < this.platformCount; i += 1) {
            platform = this.platformPool[i];
            //check if the platform is visible and is waiting to be created;
            if (platform.visible && platform.waitingToBeCreated) {
                //if the platform is within the screen
                if (platform.position.y < -this.cameraContainer.y + (CC.WebApp.current.screenHeight * 0.5)
                    && platform.position.y > -this.cameraContainer.y - (CC.WebApp.current.screenHeight * 0.5)) {
                    platform.inputOn(null);
                }
            }
        }
    }

};

var JumpGamePoints = function (textJson) {
    PIXI.Container.call(this);
    this.visible = false;
    this.text = new PIXI.extras.BitmapText("1", {font: textJson.textSize + "px Futura", tint: textJson.tint});
    this.addChild(this.text);
};

JumpGamePoints.prototype = Object.create(PIXI.Container.prototype);
JumpGamePoints.prototype.constructor = JumpGamePoints;

JumpGamePoints.prototype.show = function (x, y, score) {

    this.text.alpha = 1;
    this.text.text = score;
    this.text.x = this.text.width * -0.5;
    this.text.y = 0;
    this.visible = true;
    this.x = x;
    this.y = y;
    TweenLite.to(this.text, 0.7, {alpha: 0, y: -100, onComplete: this.hide.bind(this)});
};

JumpGamePoints.prototype.hide = function () {
    this.text.alpha = 1;
    this.visible = false;
};

Math.greatestCommonDivisor = function (a, b) {
    var t;
    while (b !== 0) {
        t = b;
        b = a % b;
        a = t;
    }
    return a;
};

Math.lowestCommonMultiplier = function (a, b) {
    return (a * b / Math.greatestCommonDivisor(a, b));
};

Math.lowestCommonMultiplierMultiple = function (numbers) {
    if (numbers.length === 2) {
        return Math.lowestCommonMultiplier(numbers[0], numbers[1]);
    }
    else {
        var firstNumber = numbers[0];
        numbers.shift();
        return Math.lowestCommonMultiplier(firstNumber, Math.lowestCommonMultiplierMultiple(numbers));
    }
};

